<tds-header>
  <tds-header-hamburger
    (click)="mobileMenuAction()"
    aria-expanded="false"
    aria-haspopup="true"
  ></tds-header-hamburger>
  <tds-header-title class="tds-headline-04">{{descHeader()}}</tds-header-title>
  <tds-header-brand-symbol slot="end">
    <a aria-label="Scania - red gryphon on blue shield" routerLink="/version"></a>
  </tds-header-brand-symbol>
</tds-header>
